export default "__VITE_ASSET__d38d843d__"